/* ══════════════════════════════════════════════════════════════
   ALSACE — LUXE concept JS
   - Header scrolled-state toggling
   - Deco carousels (vanilla)
   - Category hover image swap
   Queries operate across all `.alsace-home` wrappers on the page.
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function init() {
    if (document.__alsaceInit) return;
    document.__alsaceInit = true;

    // ── Header scrolled-state ──
    var header = document.querySelector('#alsaceSiteHeader') || document.querySelector('.alsace-home .site-header');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 60) header.classList.add('scrolled');
        else header.classList.remove('scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      // Safety net: scroll events can be missed during momentum scroll /
      // bfcache restore, leaving the header stuck in the wrong state.
      window.addEventListener('pageshow', onScroll);
      if ('onscrollend' in window) window.addEventListener('scrollend', onScroll, { passive: true });
      window.addEventListener('touchend', function () { setTimeout(onScroll, 120); }, { passive: true });
      onScroll();
    }

    // ── Mobile burger menu ──
    var burgers = document.querySelectorAll('.alsace-home [data-burger]');
    if (burgers.length) {
      var toggleDrawer = function () {
        var open = document.body.classList.toggle('alsace-drawer-open');
        document.querySelectorAll('.alsace-home .header-burger').forEach(function (b) {
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      };
      burgers.forEach(function (b) { b.addEventListener('click', toggleDrawer); });
    }

    // ── Mega menu hover with leave-delay ──
    document.querySelectorAll('.alsace-home .header-nav-item.has-mega').forEach(function (item) {
      if (item.__megaInit) return;
      item.__megaInit = true;
      var hideTimer = null;
      var open = function () {
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        item.classList.add('is-mega-open');
      };
      var scheduleClose = function () {
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          item.classList.remove('is-mega-open');
        }, 220);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', scheduleClose);
    });

    // ── Deco carousels (desktop only; mobile uses native horizontal scroll) ──
    var isMobile = function () { return window.matchMedia('(max-width: 768px)').matches; };


    document.querySelectorAll('.alsace-home [data-deco-carousel]').forEach(function (car) {
      if (car.__init) return;
      if (isMobile()) return; // skip init on mobile so native scroll works
      car.__init = true;
      var track  = car.querySelector('.deco-slides-track');
      var slides = car.querySelectorAll('.deco-slide');
      var dots   = car.querySelectorAll('.deco-dot');
      var prev   = car.querySelector('.deco-carousel-arrow.prev');
      var next   = car.querySelector('.deco-carousel-arrow.next');
      if (!track || slides.length === 0) return;
      var cur = 0;
      function goTo(n) {
        if (dots[cur]) dots[cur].classList.remove('is-active');
        cur = ((n % slides.length) + slides.length) % slides.length;
        if (dots[cur]) dots[cur].classList.add('is-active');
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
      }
      if (next) next.addEventListener('click', function () { goTo(cur + 1); });
      if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); });
      });
      goTo(0);
    });

    // ── Category hover image swap ──
    document.querySelectorAll('.alsace-home [data-cat-section]').forEach(function (section) {
      if (section.__init) return;
      section.__init = true;
      var items  = section.querySelectorAll('.cat-list-item');
      var images = section.querySelectorAll('.cat-image-slot');
      if (!items.length || !images.length) return;
      var cur = 0;
      function activate(n) {
        if (items[cur])  items[cur].classList.remove('is-active');
        if (images[cur]) images[cur].classList.remove('is-active');
        cur = n;
        if (items[cur])  items[cur].classList.add('is-active');
        if (images[cur]) images[cur].classList.add('is-active');
      }
      items.forEach(function (item, i) {
        item.addEventListener('mouseenter', function () { activate(i); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
